import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { SubmitButtonClickService } from 'src/app/services/submit-button-click.service';
import { Router } from '@angular/router';
import { ApiConstants } from 'src/app/constants/api-constants';
import * as cryptoJS from 'crypto-js';
import { Utilities } from 'src/app/constants/utilities';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})
export class ChangePasswordModalComponent implements OnInit, OnDestroy {
  @Input() username: any;
  @Input() message: any;
  @Input() oldPassword: any;
  @Input() statusMessage: any;

  hide = true;
  passwordForm: FormGroup;
  submitted: boolean = false;
  errorMessage: any = null;
  private _loading: boolean = false;
  private _secretKey = ApiConstants.secretKey;
  private _passwordFormSubscription: Subscription;
  private _changePasswordSubscription: Subscription;
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _service: ServicecallService,
    private _router: Router,
    private _dialog: MatDialog
  ) {
    this.passwordForm = this._fb.group({
      oldPassword: ["", [Validators.required]],
      password: [""],
    });
    this._passwordFormSubscription = this.passwordForm.valueChanges.subscribe(() => {
      if (this.submitted) {
        this.submitted = false;
        this.errorMessage = null;
      }
    });
  }

  ngOnInit(): void {
    if (this.oldPassword && this.statusMessage != 'Expired') {
      this.passwordForm.patchValue({ oldPassword: this.oldPassword })
    }
  }
  ngOnDestroy(): void {
    this._passwordFormSubscription?.unsubscribe();
    this._changePasswordSubscription?.unsubscribe();  
  }
  onSubmit() {
    this._submitButtonClick.setSubmitButtonClick('clicked');
    this._loading = true;
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return
    }
    this.errorMessage = null;
    let currentTime = Utilities.getCurrentTimeFormat()
    this._changePasswordSubscription = this._service.changePassword(this.username, this._encrypt(this.passwordForm.value.oldPassword), this._encrypt(this.passwordForm.value.password.password), currentTime).subscribe((res: any) => {
      if (res['status']) {
        this._activeModal.close();
        let dialogRef = this._dialog.open(AlertDialogComponent, {
          data: { msg: 'Your password changed successfully. Please login again!', type: 'hideCancel' },
          disableClose: true
        });
        this._logout();
        this.errorMessage = null;
        // alert('Your password changed successfully.Please login again!');
      } else {
        this.errorMessage = res['response']['message'];
      }
    })
  }
  
  closeModal() {
    this._activeModal.close();
  }
  get passwordFormValues() {
    return this.passwordForm.controls;
  }
  private _encrypt(value: string): string {
    let k = cryptoJS.enc.Utf8.parse(this._secretKey.trim());
    let cypher = cryptoJS.AES.encrypt(value, k, { mode: cryptoJS.mode.ECB })
    return cryptoJS.enc.Hex.stringify(cypher.ciphertext);
  }
  private _logout() {
    this._service.clearDateState('all');
    this._service.setVehicleDateRange(null);
    this._router.navigate(['/login']);
    localStorage.clear();
    sessionStorage.clear();
  }
}
